export interface PlatformReplySubmitIntent {
  getKey: () => string
  invalidate: () => void
}

/** Keeps one key for an ambiguous retry and forgets it when the intent changes. */
export const createPlatformReplySubmitIntent = (
  createKey: () => string
): PlatformReplySubmitIntent => {
  let pendingKey: string | null = null

  return {
    getKey: () => {
      pendingKey ??= createKey()
      return pendingKey
    },
    invalidate: () => {
      pendingKey = null
    },
  }
}
